import { FC } from 'react';
import supplierCreated from '../../../assets/supplierCreated.svg';

export const RequsetNewSlotSuccess: FC = () => (
    <div className="SupplierCompanyPitches__success success">
        <div className="success__block">
            <div className="preferences-submitted">
                <h1 className="preferences-submitted__title">Alternative Slot Request Submitted</h1>

                <p className="preferences-submitted__text">Your request has been sent to the Customer.</p>

                <p className="preferences-submitted__text">
                    You will be notified once revised time options are confirmed.
                </p>
                <p className="preferences-submitted__text">
                    Your originally allocated slot remains scheduled until changes are agreed.
                </p>

                <div className="preferences-submitted__contact">
                    <p className="preferences-submitted__text">
                        If you have any questions, please contact the support team at{' '}
                        <a href="mailto:support@askproco.com" className="preferences-submitted__link">
                            support@askproco.com
                        </a>
                    </p>

                    <p className="preferences-submitted__text">
                        or contact us directly at{' '}
                        <span className="preferences-submitted__phone">+27 (0) 21 565 0401</span>
                    </p>
                </div>
            </div>
        </div>
        <img src={supplierCreated} className="image__item" alt="" />
    </div>
);
